<template>
  <div id="delivery-form-view">
    <div class="grid-row">
      <div class="column">
        <div class="delivery-form-view-header">
          <h1>{{$_('my_delivery_forms')}}</h1>
          <p>{{$_('my_delivery_forms_text')}}</p>
        </div>
      </div>
    </div>
    <DeliveryFormResearch />
    <div class="grid-row">
      <div class="column">
        <DeliveryFormList />
      </div>
    </div>
  </div>
</template>

<script>

import DeliveryFormList from '@/modules/facture/components/DeliveryFormList';
import DeliveryFormResearch from '@/modules/facture/components/DeliveryFormResearch';

export default {
  components: {
    DeliveryFormList,
    DeliveryFormResearch
  },
  created() {
    this.$store.dispatch('facture/RESET_DELIVERY_RESEARCH');
  }
}
</script>

<style scoped>
</style>